import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useGlobalContext } from "./../component/GlobalContext";
import {
  MenuOutlined,
  DownOutlined,
  LogoutOutlined,
  DashboardOutlined,
  UserOutlined,
  GiftOutlined,
  TeamOutlined,
  AppstoreOutlined,
  PictureOutlined,
  CalendarOutlined
} from "@ant-design/icons";
import { Dropdown, Menu, Avatar, Button, Drawer } from "antd";
import Tippy from "@tippyjs/react";

const Header = () => {
  const { globalUserVar, isAuthenticated, setIsAuthenticated, isActiveMember } = useGlobalContext();
  const [firstName, setFirstName] = useState("");
  const [role, setRole] = useState("");
  const [planType, setPlanType] = useState("");
  const [planAmount, setPlanAmount] = useState("");
  const [drawerVisible, setDrawerVisible] = useState(false);

  const navigate = useNavigate();
  const currentLocation = useLocation();

  useEffect(() => {
    if (isAuthenticated) {
      const userObj = localStorage.getItem("userObj");
      if (userObj) {
        const userJson = JSON.parse(userObj);
        setFirstName(userJson.first_name);
        setRole(userJson.role.name);
        setPlanType(userJson.plan_type);
        setPlanAmount(userJson.plan_amount);
      }
    }
  }, [isAuthenticated, isActiveMember]);

  const logOutHandler = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    navigate("/");
  };

  const membershipMenu = (
    <Menu>
      <Menu.Item key="1">
        <Link to="/subscription/member">Join the Family Fun Club</Link>
      </Menu.Item>
      {!isAuthenticated && (
        <Menu.Item key="2">
          <Link to="/login">Family Sign In</Link>
        </Menu.Item>
      )}
    </Menu>
  );

  const businessPartnerMenu = (
    <Menu>
      <Menu.Item key="1">
        <Link to="/subscription/vendor">Register as a Business Partner</Link>
      </Menu.Item>
      {!isAuthenticated && (
        <Menu.Item key="2">
          <Link to="/vendor/login">Business Sign In</Link>
        </Menu.Item>
      )}
    </Menu>
  );

  const userMenu = (
    <Menu>
      <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
        <Link to="/dashboard">Dashboard</Link>
      </Menu.Item>
      <Menu.Item key="account" icon={<UserOutlined />}>
        <Link to="/account-details">Account Details</Link>
      </Menu.Item>
      <Menu.Item key="coupons" icon={<GiftOutlined />}>
        <Link to="/coupons">Deals</Link>
      </Menu.Item>
      {role === "Admin" && (
        <>
          <Menu.Item key="vendors" icon={<TeamOutlined />}>
            <Link to="/vendors">Vendors</Link>
          </Menu.Item>
          <Menu.Item key="members" icon={<UserOutlined />}>
            <Link to="/members">Members</Link>
          </Menu.Item>
          <Menu.Item key="categories" icon={<AppstoreOutlined />}>
            <Link to="/categories">Categories</Link>
          </Menu.Item>
          <Menu.Item key="gallery" icon={<PictureOutlined />}>
            <Link to="/media-gallery">Gallery</Link>
          </Menu.Item>
          <Menu.Item key="events" icon={<CalendarOutlined />}>
            <Link to="/events">Events</Link>
          </Menu.Item>
        </>
      )}
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={logOutHandler}>
        Log Out
      </Menu.Item>
    </Menu>
  );

  const signInMenu = (
    <Menu>
      <Menu.Item key="member">
        <Link to="/login">Family Sign in</Link>
      </Menu.Item>
      <Menu.Item key="partner">
        <Link to="/vendor/login">Business Sign in</Link>
      </Menu.Item>
    </Menu>
  );

  return ( 
    <>
      <nav className="border-b bg-white z-50 relative ">
        {/* <div className="flex justify-between items-center px-4 py-3 md:px-6"> */}
        <div className="flex justify-between items-center 
px-2 py-2               
sm:px-3 sm:py-2.5       
md:px-3 md:py-1.5         
lg:px-2 lg:py-1.5         
xl:px-8 xl:py-2
2xl:px-4 2xl:py-2">
          <Link to="/" className="flex items-center">
            <img src="/logo-CwJXNP93.svg" alt="Logo" className="h-12 w-[82px] header-logo" />
          </Link>
          <div className="xl:hidden">
            <Button type="text" icon={<MenuOutlined />} onClick={() => setDrawerVisible(true)} />
          </div>
          <div className="hidden xl:flex items-center gap-4">
            {isAuthenticated && isActiveMember && (
              <span className="text-sm font-semibold">
                (Active Plan - {planType === "month" ? `Monthly : $${planAmount}` : `Annual : $${planAmount}`})
              </span>
            )}
            <Link to="/" className={`text-sm font-semibold p-1 ${
                currentLocation.pathname === "/"
                  ? "text-primary"
                  : "hover:text-primary"
              }`}>Home </Link>
            <Link to="/event-calender" className={`text-sm font-semibold p-1 ${
                currentLocation.pathname === "/event-calender"
                  ? "text-primary"
                  : "hover:text-primary"
              }`}>Events Calendar</Link>

            <Dropdown overlay={membershipMenu} trigger={['click']}>
              <span className={`text-sm font-semibold cursor-pointer p-1 ${
                currentLocation.pathname === "/subscription/member" || currentLocation.pathname === "/member/register"
                  ? "text-primary"
                  : "hover:text-primary"
              }`}>
                Family Membership <DownOutlined className="ml-1 text-xs" />
              </span>
            </Dropdown>

            <Dropdown overlay={businessPartnerMenu} trigger={['click']}>
              <span className={`text-sm font-semibold cursor-pointer p-1 ${
                currentLocation.pathname === "/subscription/vendor" || currentLocation.pathname === "/vendor/register"
                  ? "text-primary"
                  : "hover:text-primary"
              }`}>
                Business Partners <DownOutlined className="ml-1 text-xs" />
              </span>
            </Dropdown>

            <Link to="/contact-us" className={`text-sm font-semibold p-1 ${
                currentLocation.pathname === "/contact-us"
                  ? "text-primary"
                  : "hover:text-primary"
              }`}>Contact Us</Link>
            <a href="https://www.facebook.com/familyfunaz/events" target="_blank" rel="noreferrer" className="text-sm font-semibold hover:text-primary p-1">Get Social</a>

            <div className="flex items-center gap-2 ml-4 p-1">
              {isAuthenticated ? (
                <Dropdown overlay={userMenu} trigger={['click']}>
                  <span className="flex items-center gap-1 cursor-pointer">
                    <Tippy content={`${role === "vendor" ? "User" : firstName}`}>
                      <span className="text-sm font-medium">{role === "vendor" ? "User" : firstName}</span>
                    </Tippy>
                    <DownOutlined className="text-xs" />
                  </span>
                </Dropdown>
              ) : (
                <Dropdown overlay={signInMenu} trigger={['click']}>
                  <span className={`text-sm font-semibold hover:text-primary cursor-pointer ${
                currentLocation.pathname === "/login" || currentLocation.pathname === "/vendor/login"
                  ? "text-primary"
                  : "hover:text-primary"
              }`}>
                    Sign in <DownOutlined className="ml-1 text-xs" />
                  </span>
                </Dropdown>
              )}
            </div>
          </div>
        </div>
      </nav>
      {/* 25dvh */}

      <Drawer
        title={<><p>Menu</p> 
        {/* <p>menu 2</p> */}
        </>}
        placement="left"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        className="md:hidden mobile-drawer mobile-drawer-custom"
      >
        {isAuthenticated && isActiveMember && (
          <p className="mb-2">(Active Plan - {planType === "month" ? `Monthly : $${planAmount}` : `Annual : $${planAmount}`})</p>
        )}
        <Menu mode="vertical" onClick={() => setDrawerVisible(false)} className="mobile-drawer-custom">
          <Menu.Item><Link to="/">Home</Link></Menu.Item>
          <Menu.Item><Link to="/event-calender">Events Calendar</Link></Menu.Item>
          <Menu.Item><Link to="/subscription/member">Join the Family Fun Club</Link></Menu.Item>
          {!isAuthenticated && <Menu.Item><Link to="/login">Family Sign In</Link></Menu.Item>}
          <Menu.Item><Link to="/subscription/vendor">Register as a Business Partner</Link></Menu.Item>
          {!isAuthenticated && <Menu.Item><Link to="/vendor/login">Business Sign In</Link></Menu.Item>}
          <Menu.Item><Link to="/contact-us">Contact Us</Link></Menu.Item>
          <Menu.Item><a href="https://www.facebook.com/familyfunaz/events" target="_blank" rel="noreferrer">Get Social</a></Menu.Item>

          {isAuthenticated && (
            <>
              <Menu.Divider />
              <Menu.Item><Link to="/dashboard">Dashboard</Link></Menu.Item>
              <Menu.Item><Link to="/account-details">Account Details</Link></Menu.Item>
              <Menu.Item><Link to="/coupons">Deals</Link></Menu.Item>
              {role === "Admin" && (
                <>
                  <Menu.Item><Link to="/vendors">Vendors</Link></Menu.Item>
                  <Menu.Item><Link to="/members">Members</Link></Menu.Item>
                  <Menu.Item><Link to="/categories">Categories</Link></Menu.Item>
                  <Menu.Item><Link to="/media-gallery">Gallery</Link></Menu.Item>
                  <Menu.Item><Link to="/events">Events</Link></Menu.Item>
                </>
              )}
              <Menu.Item onClick={logOutHandler}>Log Out</Menu.Item>
            </>
          )}
        </Menu>
      </Drawer>
    </>
  );
};

export default Header;
